import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './sidebar.css'; // Add necessary styles for the navbar
import axios from '../../../axiosInstance';

function Sidebar_admin() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed
  const navigate = useNavigate();

  // Handle logout functionality
  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('sessiontoken'); 

      if (!token) {
        alert("You are not logged in!");
        return;
      }

      const response = await axios.post('/api/reporter/logout', {}, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      localStorage.removeItem('token');
      alert(response.data.message);
      navigate('/reporter/login');
    } catch (error) {
      console.error('Logout failed:', error.response?.data || error.message);
      alert('Logout failed. Please try again.');
    }
  };

  // Handle window resize to toggle between mobile and desktop layouts
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      {isMobile && isSidebarOpen && (
        <div className="overlay" onClick={() => setIsSidebarOpen(false)}></div>
      )}
      {isMobile ? (
        // Mobile Navbar with toggle menu
        <nav className="navbar">
          <div className="navbar-container">
            <h2 className="navbar-title">TODAY LOCAL</h2>
            <button
              className="navbar-toggle"
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            >
              <i className={`fas ${isSidebarOpen ? 'fa-times' : 'fa-bars'}`}></i>
            </button>
          </div>
          {isSidebarOpen && (
            <ul className="navbar-menu">
              <li><Link to="/admin/dashboard" onClick={() => setIsSidebarOpen(false)}>Dashboard</Link></li>
              <li><Link to="/admin/AdminNewsManagement" onClick={() => setIsSidebarOpen(false)}>News</Link></li>
              <li><Link to="/admin/Repotermanagement" onClick={() => setIsSidebarOpen(false)}>Repoters</Link></li>
              <li><Link to="/admin/views/management" onClick={() => setIsSidebarOpen(false)}>Views</Link></li>
              <li><Link to="/admin/Earnings/management" onClick={() => setIsSidebarOpen(false)}>Earnings</Link></li>
              <li><Link to="/admin/Runningbar/update" onClick={() => setIsSidebarOpen(false)}>Running Bar</Link></li>
              <li><Link to="/admin/ads/management" onClick={() => setIsSidebarOpen(false)}>Ads</Link></li>
              <li><Link to="/admin/channel/management" onClick={() => setIsSidebarOpen(false)}>Channels</Link></li>
              <li>
                <Link to="#" className="logout-link" onClick={() => { setIsSidebarOpen(false); handleLogout(); }}>
                  <i className="fas fa-sign-out-alt"></i> Logout
                </Link>
              </li>
            </ul>
          )}
        </nav>
      ) : (
        // Desktop Sidebar
        <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
          <h2 className="sidebar-title">TODAY LOCAL</h2>
          <ul>
            <li><Link to="/admin/dashboard">Dashboard</Link></li>
            <li><Link to="/admin/AdminNewsManagement">News</Link></li>
            <li><Link to="/admin/Repotermanagement">Repoters</Link></li>
            <li><Link to="/admin/views/management">Views</Link></li>
            <li><Link to="/admin/Earnings/management">Earnings</Link></li>
            <li><Link to="/admin/Runningbar/update">Running Bar</Link></li>
            <li><Link to="/admin/ads/management">Ads</Link></li>
            <li><Link to="/admin/channel/management">Channels</Link></li>
            


          </ul>
          <ul className="logout-section">
            <li>
              <Link to="#" className="logout-link" onClick={handleLogout}>
                <i className="fas fa-sign-out-alt"></i> Logout
              </Link>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

export default Sidebar_admin;
